/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Tabs,
  Modal,
  DatePicker,
} from 'antd';
import {
  CheckCircleOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons';
import Select from 'components/Select';
import { onError, onSuccess } from 'utils/handlers';
import {
  getEstadosGlobales,
} from 'api/catalogos';
import Table from 'components/Table';
import { ESTATUS_ACTIVO, ESTATUS_AUTORIZADO, ESTATUS_INACTIVO } from 'utils/constants';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import FormSubmitControls from 'components/FormSubmitControls';
import {
  autorizarIncidenciaValidacion,
  deleteIncidenciaValidacion,
  getIncidenciaValidacion, getIncidenciasValidaciones, getIncidenciasValidacionesPag, patchIncidenciaValidacion, postIncidenciaValidacion,
} from 'api/configuraciones/clock/Incidencias/IncidenciaValidacion';
import { formatReceived, formatReceivedValues } from 'utils/formatValues';
import moment from 'moment/moment';
import { getConfiguracionIncidencias } from 'api/nominas/incidencias/configuracionIncidencias';
import { getTiposDeIncidenciasUnidades } from 'api/nominas/incidencias/tiposIncidenciasUnidades';
import { getAplicaciones } from 'api/catalogos/PeriocidadDeAplicacion';
import { getEvaluacionesAsistencia } from 'api/catalogos/TiposDeEvaluacionAsistencia';

export const validacionesAusentismoPermission = {
  permissionModel: 'incidenciavalidacion',
  catalogsModels: [],
  tabsModels: [],
};

const ValidacionesAusentismoReloj = ({ permission }) => {
  const [form] = Form.useForm();
  const [isAdding, setAdding] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [disableFields, setDisableFields] = useState(true);
  const [pageActual, setPageActual] = useState(1);
  const [evaluacionAsistencia, setEvaluacionAsistencia] = useState([]);
  const [incidencia, setIncidencia] = useState([]);

  const [empleadoSelected, setEmpleadoSelected] = useState([]);

  const formInstances = [
    form,
  ];

  const numeroDias = (fieldName) => (e) => {
    const rawValue = e.target.value;

    // Keep only digits
    const filtered = rawValue.replace(/\D/g, '');

    // Convert to number
    const num = Number(filtered);

    // Only update if it's greater than 0
    if (num > 0) {
      form.setFieldsValue({ [fieldName]: num });
    } else {
      // If it's 0 or less, maybe clear it or set empty string
      form.setFieldsValue({ [fieldName]: '' });
    }
  };

  const fetchPaginated = async (page = 1, q = null) => {
    try {
      setLoading(true);

      const cleanPage = Number(String(page).replace(/\D/g, ''));
      const _data = await getIncidenciasValidacionesPag({ page: cleanPage, ...q });

      const { results } = _data;

      setSelectedRowKeys([]);
      setPageActual(cleanPage);
      setData({ ..._data, results: [...results] });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    const _data = await getIncidenciasValidaciones();
    setData(formatReceived(_data));
    setLoading(false);
  };
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _incidencias,
        _tipoEvaluacionAsistencia,
        _data,
        _estados,
      ] = await Promise.all([
        getConfiguracionIncidencias({ estados_globales: ESTATUS_AUTORIZADO }),
        getEvaluacionesAsistencia({ estados_globales: ESTATUS_AUTORIZADO }),
        getIncidenciasValidaciones(),
        getEstadosGlobales(),
      ]);
      if (mounted) {
        setIncidencia(_incidencias);
        setEvaluacionAsistencia(_tipoEvaluacionAsistencia);
        setData(_data);
        setEstados(_estados);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setSelectedRowKeys([]);
    setSelectedData({});
  };
  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    setAdding(false);
    const [key] = selectedRowKeys;
    const match = responseData || data?.results?.find((item) => item.id === key);
    const _validacionesConfigReloj = await getIncidenciaValidacion(match.id);

    setTimeout(() => {
      if (_validacionesConfigReloj) {
        const empleado = _validacionesConfigReloj?.empleado;
        setEmpleadoSelected([empleado]);
        const _empleado_nombre = empleado
          ? `${empleado?.nombre ?? ''} ${empleado?.apellido_paterno ?? ''} ${empleado?.apellido_materno ?? ''}`.trim()
          : '';
        const formValues = {
          ...formatReceived(_validacionesConfigReloj),
          concepto_incidencia: _validacionesConfigReloj.concepto_incidencia?.id,
          concepto_evaluacion: _validacionesConfigReloj.concepto_evaluacion?.id,
          empleado: empleado?.id,
          fecha_inicial: _validacionesConfigReloj.fecha_inicial
            ? moment(_validacionesConfigReloj.fecha_inicial)
            : null,
          fecha_final: _validacionesConfigReloj.fecha_final
            ? moment(_validacionesConfigReloj.fecha_final)
            : null,

          // Asigna el ID del estado global
          estados_globales: _validacionesConfigReloj.estados_globales?.id, //  aquí sí es un ID
        };
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(formValues));
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };
  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });

    const dataForForm = {
      ...record,
      vigencia_final: record.vigencia_final
        ? moment(record.vigencia_final)
        : null,
      fecha_inicial: record.fecha_inicial
        ? moment(record.fecha_inicial)
        : null,
      fecha_final: record.fecha_final
        ? moment(record.fecha_final)
        : null,
    };

    form.setFieldsValue(dataForForm);
  };
  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        return;
      }
      const saved = await autorizarIncidenciaValidacion(key);
      if (saved) {
        const _data = await getIncidenciasValidaciones();
        setData(formatReceived(_data));
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Empleado',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 200,
      render: (_, record) => {
        const empleado = record?.empleado;
        return empleado
          ? [empleado?.nombre, empleado?.apellido_paterno, empleado?.apellido_materno]
            .filter(Boolean) // quita undefined/null/false
            .join(' ')
          : '';
      },
    },
    {
      titleText: 'Área',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 200,
      render: (_, record) => {
        const empleado = record?.empleado;
        return empleado?.directorio_de_area_clave_y_nombre
          || '';
      },
    },
    {
      titleText: 'Puesto',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 200,
      render: (_, record) => {
        const empleado = record?.empleado;
        return empleado?.puesto_clave_y_descripcion
          || '';
      },
    },
    {
      titleText: 'Plaza',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 200,
      render: (_, record) => {
        const empleado = record?.empleado;
        return empleado?.plaza_clave_y_descripcion
          || '';
      },
    },
    {
      titleText: 'Concepto de Incidencia',
      dataIndex: 'concepto_incidencia',
      key: 'concepto_incidencia',
      width: 200,
      render: (_, record) => `${record?.concepto_incidencia?.clave}  ${record?.concepto_incidencia?.concepto}` || '',
    },
    {
      titleText: 'Concepto de Evaluación',
      dataIndex: 'concepto_evaluacion',
      key: 'concepto_evaluacion',
      width: 200,
      render: (_, record) => record?.concepto_evaluacion?.nombre || '',
    },
    {
      titleText: 'No. de Días',
      dataIndex: 'numero_de_dias',
      key: 'numero_de_dias',
      width: 150,
    },
    {
      titleText: 'Fecha Inicial',
      dataIndex: 'fecha_inicial',
      key: 'fecha_inicial',
      width: 150,
    },
    {
      titleText: 'Fecha Final',
      dataIndex: 'fecha_final',
      key: 'fecha_final',
      width: 150,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  return (
    <Row align="center" justify="center" className="container">
      <Col span={24}>
        <Spin tip="Cargando..." spinning={loading}>
          <Table
            cols={columns}
            data={data?.results || []}
            pagination={false}
            paginationCallback={fetchPaginated}
            count={data?.count || 0}
            rowSelection={rowSelection}
            onRow={(record) => ({
              onClick: () => handleOnRowClick(record),
              onDoubleClick: () => onClickEdit(record),
            })}
            customActions={[{
              onClick: () => onClickEdit(),
              text: 'Visualizar',
              icon: <UnorderedListOutlined />,
              disabledBySelection: true,
            },
            {
              onClick: () => setVisibleAutorizar(true),
              permission: { model: 'incidenciavalidacion', action: 'autorizar' },
              icon: <CheckCircleOutlined />,
              text: 'Autorizar',
              disabledBySelection: true,
              disabled: selectedData?.estados_globales?.id !== ESTATUS_ACTIVO,
              className: 'success',
            },
            ]}
            permission={permission}
          />
          <Modal
            open={open}
            closable={false}
            maskClosable={!loading}
            keyboard={!loading}
            footer={null}
            title={(
              <FormSubmitControls
                label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Incidencia Validacion`}
                onCancel={onCancel}
                loading={loading}
              />
            )}
            onCancel={onCancel}
            forceRender
          >
            <Form
              layout="vertical"
              form={form}
              scrollToFirstErrorDatePicker
              name="Validacion"
              initialValues={{
                estados_globales: ESTATUS_ACTIVO,
              }}
            >
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="empleado"
                  label="Empleado"
                >
                  <Select
                    labelProp="numero_y_nombre_completo"
                    keyProp="id"
                    dataSource={empleadoSelected}
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="empleado"
                  label="Área"
                >
                  <Select
                    labelProp="directorio_de_area_clave_y_nombre"
                    keyProp="id"
                    dataSource={empleadoSelected}
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="empleado"
                  label="Puesto"
                >
                  <Select
                    labelProp="puesto_clave_y_descripcion"
                    keyProp="id"
                    dataSource={empleadoSelected}
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="empleado"
                  label="Plaza"
                >
                  <Select
                    labelProp="plaza_clave_y_descripcion"
                    keyProp="id"
                    dataSource={empleadoSelected}
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="concepto_incidencia"
                  label="Concepto de Incidencia"
                  hasFeedback
                >
                  <Select
                    dataSource={incidencia.map((_incidencia) => ({ id: _incidencia?.id, descripcion: `${_incidencia?.clave}  ${_incidencia?.concepto}` }))}
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="concepto_evaluacion"
                  label="Concepto de Evaluación"
                  hasFeedback
                >
                  <Select
                    labelProp="nombre"
                    keyProp="id"
                    dataSource={evaluacionAsistencia}
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="numero_de_dias"
                  label="No. de Días"
                >
                  <Input
                    allowClear
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="fecha_inicial"
                  label="Fecha Inicial"
                  hasFeedback
                >
                  <DatePicker
                    allowClear
                    format="YYYY-MM-DD"
                    disabled={disableFields}
                    placeholder=""
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="fecha_final"
                  label="Fecha Final"
                  hasFeedback
                >
                  <DatePicker
                    allowClear
                    format="YYYY-MM-DD"
                    disabled={disableFields}
                    placeholder=""
                  />
                </Form.Item>
              </Col>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Modal>
          <ModalConfirmation
            onFinish={onConfirmAutorizar}
            ConfirmAutorize
            onCancel={() => setVisibleAutorizar(false)}
            contentTitle="Autorizar Incidencia Validación"
            open={visibleAutorizar}
            loading={loading}
          />
        </Spin>
      </Col>
    </Row>
  );
};

export default ValidacionesAusentismoReloj;
